/**
 * Runtime-aware access to REACT_APP_* configuration.
 *
 * Resolution order:
 *   1. window.__ENV__  — written at container start by docker/40-env-config.sh
 *      from the container's REACT_APP_* environment variables (/env-config.js).
 *   2. process.env     — values inlined by CRA at build time (.env).
 *
 * Empty strings are treated as "not set".
 */
const isSet = (value) => value !== undefined && value !== null && value !== "";

export const getEnv = (key, { required = false } = {}) => {
  const runtimeValue = (typeof window !== "undefined" && window.__ENV__?.[key]);
  if (isSet(runtimeValue)) return runtimeValue;

  const buildValue = process.env[key];
  if (isSet(buildValue)) return buildValue;

  if (required) {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  return undefined;
};

export default getEnv;
